import { Modal } from '@ethsign/ui';
import React from 'react';

import { ColorAlertIcon, ColorWarningIcon } from '@/components';

export const AccountChangedModal = ({
  open,
  onOpenChange
}: {
  onOpenChange: (open: boolean) => void;
  open: boolean;
}) => {
  return (
    <Modal open={open} onOpenChange={onOpenChange} footer={false} className={'md:w-[364px]'}>
      <div className="flex items-center flex-col justify-center">
        <ColorWarningIcon />
        <div className="text-lg font-medium text-gray-900 mt-[20px]">Account Switched</div>
        <div className="text-sm text-gray-500 mt-[8px] mb-[20px]  text-center">
          It seems you have switched the connected account in your wallet. Please switch back to the previous account or
          login again with your new account.
        </div>
      </div>
    </Modal>
  );
};

export const AccountSwitchModal = ({
  open,
  onOpenChange,
  onConfirm
}: {
  onOpenChange: (open: boolean) => void;
  open: boolean;
  onConfirm: () => void;
}) => {
  return (
    <Modal
      hiddenCloseIcon
      maskClosable={false}
      open={open}
      onOpenChange={onOpenChange}
      className={'md:w-[433px]'}
      cancelText={'Keep Current'}
      confirmText={'Switch'}
      onConfirm={onConfirm}
      confirmButtonProps={{
        variant: 'primary'
      }}
    >
      <div className="flex items-center flex-col justify-center">
        <ColorAlertIcon />
        <div className="text-lg font-medium text-gray-900 mt-[20px]">New Wallet Account Detected</div>
        <div className="text-sm text-gray-500 mt-[8px] mb-[20px]  text-center">
          A different wallet account has been detected for your login. Would you like to switch accounts?
        </div>
      </div>
    </Modal>
  );
};
